export default __webpack_public_path__ + "static/media/q2_step1.5f43a732.png";